import { z } from 'zod';
export const MeetingsDataSourceSchema = z.enum(['Auth0', 'Verisk', 'CSR', 'TPLAP', 'Meetings']);
